import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'

export type FacesheetCardTitleProps = ComponentPropsWithoutRef<'div'>

// Left cluster of a card's header row — conventionally FacesheetCardIcon,
// FacesheetCardLabel, FacesheetCardCollapseTrigger. The gap is tight because
// the icon does not sit in a chip that needs breathing room.
//
// It is also the collapse target: the trigger stretches over this box, so the
// row grows into the space before the actions cluster to make that target as
// wide as the header allows. The trigger is an overlay rather than a wrapper
// (see FacesheetCardCollapseTrigger), so anything genuinely interactive in the
// row has to sit above it — a positioned descendant with z-10 beats the
// overlay's z-auto whatever the DOM order.
export function FacesheetCardTitle({
  className,
  ...delegated
}: FacesheetCardTitleProps): JSX.Element {
  return (
    <div
      className={cn(
        'group/facesheet-title relative flex min-w-0 flex-1 items-center gap-1.5',
        '[&_a]:relative [&_a]:z-10',
        '[&_button:not([data-slot=facesheet-collapse-overlay])]:relative [&_button:not([data-slot=facesheet-collapse-overlay])]:z-10',
        className
      )}
      {...delegated}
    />
  )
}
